import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/domoMsgDefinitions";
import {
    DomoPassport,
    DomoPassportHeader,
    DomoPassportID,
} from "userful-chronos-app-common-js/dist/models/integration/domo";
import integrationStore from "../integrationStore";
import { domoActions } from "../domoSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    const data = JSON.parse(payload) as DomoPassport[];
    integrationStore.dispatch(domoActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as DomoPassportHeader;
    integrationStore.dispatch(domoActions.changeLoadState("RENDER"));
    integrationStore.dispatch(domoActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(domoActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as DomoPassportHeader;
    integrationStore.dispatch(domoActions.changeLoadState("RENDER"));
    integrationStore.dispatch(domoActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(domoActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    const data = JSON.parse(payload) as DomoPassportID;
    integrationStore.dispatch(domoActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    const data = JSON.parse(payload) as DomoPassport;
    integrationStore.dispatch(domoActions.addOrUpdatePassport(data));
});
